module.exports = __webpack_public_path__ + "static/img/diamond.81abfa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard/league-ad-section/diamond.png
// module id = xs6U
// module chunks = 35